export const FORM_PERCENT_VALIDATION = {
  message: 'Should be between 0 and 100!',
  validator: (_, value) => (value <= 100 && value >= 0 ? Promise.resolve() : Promise.reject()),
};
